const isTouch = () => {
  return "ontouchstart" in document.documentElement ? true : false;
};

export default isTouch;
